import { useNavigate, useParams } from 'react-router-dom';
import { Tabs } from '@/ds';
import { EmptyState } from '@/components/EmptyState';
import { ProfileTab } from './settings/ProfileTab';
import { AuditTab } from './settings/AuditTab';
import { WalletsTab } from './settings/WalletsTab';
import { ServicesTab } from './settings/ServicesTab';
import { IntegrationsTab } from './settings/IntegrationsTab';
import { PeopleTab } from './settings/PeopleTab';
import { ProjectsTab } from './settings/ProjectsTab';
import { NotificationsTab } from './settings/NotificationsTab';
import { ThresholdsTab } from './settings/ThresholdsTab';
import type { CurrentUser } from '@/api/hooks';

const TABS = [
  { value: 'profile', label: 'Профиль' },
  { value: 'services', label: 'Сервисы' },
  { value: 'notifications', label: 'Уведомления' },
  { value: 'thresholds', label: 'Пороги' },
  { value: 'wallets', label: 'Кошельки' },
  { value: 'projects', label: 'Проекты' },
  { value: 'people', label: 'Люди' },
  { value: 'integrations', label: 'Интеграции' },
  { value: 'journal', label: 'Журнал действий' },
];

export function SettingsScreen({ user }: { user: CurrentUser }) {
  const params = useParams();
  const navigate = useNavigate();
  const tab = params.tab ?? 'profile';

  return (
    <div className="kj-page">
      <div className="kj-scroll-x kj-tabs-touch">
        <Tabs
          items={TABS}
          value={tab}
          onChange={(value) => navigate(`/settings/${value}`)}
          style={{ minWidth: 'max-content' }}
        />
      </div>

      {tab === 'profile' ? (
        <ProfileTab user={user} />
      ) : tab === 'journal' ? (
        <AuditTab />
      ) : tab === 'wallets' ? (
        <WalletsTab />
      ) : tab === 'services' ? (
        <ServicesTab />
      ) : tab === 'integrations' ? (
        <IntegrationsTab />
      ) : tab === 'people' ? (
        <PeopleTab />
      ) : tab === 'projects' ? (
        <ProjectsTab />
      ) : tab === 'notifications' ? (
        <NotificationsTab />
      ) : tab === 'thresholds' ? (
        <ThresholdsTab />
      ) : (
        <EmptyState
          icon="HelpCircle"
          title="Раздел не найден"
          description="Такой вкладки в настройках нет. Выберите одну из перечисленных выше."
        />
      )}
    </div>
  );
}
